import React, { useEffect, useState } from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import SearchTemplate from '@components/Search/Search';
import TrainingsTemplate from '@components/Trainings/Trainings';
import useTranslation from '@hooks/useTranslation';
import { ACCESS_TOKEN_KEY, CONFERENCES_LIMIT_PER_PAGE, IS_PROD } from '../constants';
import { ITrainingItem } from '../interfaces/Calendar';
import { ConferenceTypes, CourseTypes, FilterTypesInUrl } from '../interfaces/Filter';
import { calendarApi } from '../services/calendar.service';

interface IConferences {
    conferences: ITrainingItem[];
    conferencesCount: number;
    filtersCount: { [key in ConferenceTypes]: number };
}

const Conferences: NextPage<IConferences> = ({ conferences, conferencesCount, filtersCount }) => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.conferences.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <TrainingsTemplate
                trainings={conferences}
                count={conferencesCount}
                conferencesFiltersCount={filtersCount}
            />
            <FooterTemplate />
        </>
    );
};

export async function getServerSideProps(ctx: any) {
    const { query } = ctx;

    const token = ctx?.res?.req?.cookies?.[ACCESS_TOKEN_KEY];

    const { data } = await calendarApi.getConferences(
        CONFERENCES_LIMIT_PER_PAGE,
        query.strana ? (Number(query.strana) - 1) * CONFERENCES_LIMIT_PER_PAGE : 0,
        query.search,
        query[FilterTypesInUrl.CITY],
        query[FilterTypesInUrl.LECTURER],
        query[FilterTypesInUrl.CONFERENCE_TYPE],
        query[FilterTypesInUrl.CONFERENCE_TYPE]?.includes(ConferenceTypes.ARCHIVED),
        query[FilterTypesInUrl.CONFERENCE_TYPE]?.includes(ConferenceTypes.UPCOMING),
        token
    );

    return {
        props: {
            conferences: data.results,
            conferencesCount: data?.total_count,
            filtersCount: {
                [ConferenceTypes.ARCHIVED]: data.filters?.archived?.count || 0,
                [ConferenceTypes.UPCOMING]: data.filters?.upcoming?.count || 0,
            },
        },
    };
}

export default Conferences;
